import React from 'react';
import { FileTextOutlined, SettingOutlined, FieldTimeOutlined } from '@ant-design/icons';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import SendIcon from '@mui/icons-material/Send';
import ChatIcon from '@mui/icons-material/Chat';
import AssignmentIcon from '@mui/icons-material/Assignment';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import TableChartIcon from '@mui/icons-material/TableChart';
import { JOB_TYPE } from './constant';
import { hasCompanyFeature } from './companyFeatures';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrown } from "@fortawesome/free-solid-svg-icons";

export const SUBMENU_ITEMS = {
  // Customfield submenu
  customfieldCase: {
    id: 'customfieldCase',
    route: 'admin/customfield/case',
    name: 'Case',
    icon: <FileTextOutlined className="text-xl" />,
  },
  customfieldAudit: {
    id: 'customfieldAudit',
    route: 'admin/customfield/audit',
    name: 'Audit',
    icon: <FileTextOutlined className="text-xl" />,
  },

  // Master Data submenu
  masterDataInput: {
    id: 'masterDataInput',
    route: 'admin/masterdata/input',
    name: 'Inputs Data',
    icon: <FileTextOutlined className="text-xl" />,
  },
  masterDataInputAudit: {
    id: 'masterDataInputAudit',
    route: 'admin/masterData/inputAudit',
    name: 'Inputs Audit Data',
    icon: <FileTextOutlined className="text-xl" />,
  },
  masterDataBlacklist: {
    id: 'masterDataBlacklist',
    route: 'admin/masterdata/blacklistTopic',
    name: 'Blacklist Topic',
    icon: <FileTextOutlined className="text-xl" />,
  },
  masterDataErrorTopic: {
    id: 'masterDataErrorTopic',
    route: 'admin/masterdata/errorTopic',
    name: 'Error Topic',
    icon: <FileTextOutlined className="text-xl" />,
  },
  masterDataNotification: {
    id: 'masterDataNotification',
    route: 'admin/masterdata/notification',
    name: 'เสียงแจ้งเตือน',
    icon: <FileTextOutlined className="text-xl" />,
  },

  //Audit Submenu
  auditCase: {
    id: 'auditCase',
    route: 'workspace/auditCase',
    name: 'Manual DEP',
    icon: <FactCheckIcon className="text-xl" />,
  },
  reportAdmin: {
    id: 'reportAdmin',
    route: 'workspace/reportAdmin',
    name: 'Report (Panel)',
    icon: <FactCheckIcon className="text-xl" />,
  },

  reportAdminInput: {
    id: 'reportAdminInput',
    route: 'workspace/reportAdminInputs',
    name: 'Report (Admin)',
    icon: <FactCheckIcon className="text-xl" />,
  },

  // Reports submenu
  reportCase: {
    id: 'reportCase',
    route: 'workspace/report',
    name: 'สรุปเวลาการจัดการเคส',
    icon: <FileTextOutlined className="text-xl" />,
  },
  errorSummary: {
    id: 'errorSummary',
    route: 'workspace/errorSummary',
    name: 'สรุปเคสผิดพลาดทั้งหมด',
    icon: <FileTextOutlined className="text-xl" />,
  },
  auditCaseReport: {
    id: 'auditCaseReport',
    route: 'workspace/auditCaseReport',
    name: 'สรุปเคสผิดพลาด',
    icon: <FileTextOutlined className="text-xl" />,
  },
  auditReport: {
    id: 'auditReport',
    route: 'workspace/audit',
    name: 'รายงานเคสทั้งหมด',
    icon: <AssignmentIcon className="text-xl" />,
  },
  employeeCaseReport: {
    id: 'employeeCaseReport',
    route: 'workspace/employeeCaseReport',
    name: 'รายงานการจัดการเคส (พนักงาน)',
    icon: <FileTextOutlined className="text-xl" />,
  },
  workloadReport: {
    id: 'workloadReport',
    route: 'workspace/workloadReport',
    name: 'รายงาน Workload',
    icon: <FileTextOutlined className="text-xl" />,
  },
  kpiReport: {
    id: 'kpiReport',
    route: 'workspace/kpiReport',
    name: 'KPI พนักงาน',
    icon: <FileTextOutlined className="text-xl" />,
  },
  attendanceReport: {
    id: 'attendanceReport',
    route: 'workspace/attendanceReport',
    name: 'เข้า-ออกงาน (รายวัน)',
    icon: <FileTextOutlined className="text-xl" />,
  },
  attendanceReportMonthly: {
    id: 'attendanceReportMonthly',
    route: 'workspace/attendanceReportMonthly',
    name: 'เข้า-ออกงาน (รายเดือน)',
    icon: <FileTextOutlined className="text-xl" />,
  },
  activityLog: {
    id: 'activityLog',
    route: 'workspace/activityLog',
    name: 'รายงาน log',
    icon: <FileTextOutlined className="text-xl" />,
  },
  birthdayPromo: {
    id: 'birthdayPromo',
    route: 'workspace/birthdayPromo',
    name: 'โปรวันเกิด',
    icon: <FileTextOutlined className="text-xl" />,
  },
  pickupTime: {
    id: 'pickupTime',
    route: 'workspace/pickupTime',
    name: 'Pickup Time',
    icon: <FileTextOutlined className="text-xl" />,
  },
};

export const MENU_ITEMS = {
  // Backoffice
  employees_backoffice: {
    id: 'employees_backoffice',
    route: 'backoffice/employees',
    name: 'พนักงาน',
    icon: <AdminPanelSettingsIcon className="text-xl" />,
  },
  companies: {
    id: 'companies',
    route: 'backoffice/companies',
    name: 'บริษัท',
    icon: <FileTextOutlined className="text-xl" />,
  },

  // Admin
  employees_admin: {
    id: 'employees_admin',
    route: 'admin/employees',
    name: 'พนักงาน',
    icon: <AdminPanelSettingsIcon className="text-xl" />,
  },
  addCaseSetting: {
    id: 'addCaseSetting',
    route: 'admin/addCaseSetting',
    name: 'Add Case Setting',
    icon: <FileTextOutlined className="text-xl" />,
  },
  setting: {
    id: 'setting',
    route: 'admin/setting',
    name: 'Setting',
    icon: <SettingOutlined className="text-xl" />,
  },
  systemJob: {
    id: 'systemJob',
    route: 'admin/systemJob',
    name: 'ระบบเชื่อมต่ออัตโนมัติ',
    icon: <DisplaySettingsIcon className="text-xl" />,
  },
  lineChannel: {
    id: 'lineChannel',
    route: 'admin/lineChannel',
    name: 'LINE OA',
    icon: <DisplaySettingsIcon className="text-xl" />,
  },
  telegramBot: {
    id: 'telegramBot',
    route: 'admin/telegramBot',
    name: 'Telegram Bot',
    icon: <DisplaySettingsIcon className="text-xl" />,
  },
  telegramChatTarget: {
    id: 'telegramChatTarget',
    route: 'admin/telegramChatTarget',
    name: 'กลุ่มส่งสลิป',
    icon: <SendIcon className="text-xl" />,
  },
  customfield: {
    id: 'customfield',
    name: 'Customfield',
    icon: <FileTextOutlined className="text-xl" />,
    subLinkIds: ['customfieldCase', 'customfieldAudit'], // Reference by ID
  },
  masterData: {
    id: 'masterData',
    name: 'Master Data',
    icon: <FileTextOutlined className="text-xl" />,
    subLinkIds: ['masterDataInput', 'masterDataInputAudit', 'masterDataBlacklist', 'masterDataErrorTopic', 'masterDataNotification'],
  },
  scheduleAdmin: {
    id: 'scheduleAdmin',
    route: 'admin/schedule',
    name: 'ตารางงาน',
    icon: <CalendarMonthIcon className="text-xl" />,
  },

  // Workspace
  dashboard: {
    id: 'dashboard',
    route: 'workspace/dashboard',
    name: 'Dashboard',
    icon: <DashboardIcon className="text-xl" />,
  },
  schedule: {
    id: 'schedule',
    route: 'workspace/schedule',
    name: 'ตารางงาน',
    icon: <CalendarMonthIcon className="text-xl" />,
  },
  case: {
    id: 'case',
    route: 'workspace/case',
    name: 'จัดการเคส',
    icon: <DisplaySettingsIcon className="text-xl" />,
    hasBadge: true,
  },
  input: {
    id: 'input',
    route: 'workspace/input',
    name: 'ส่งข้อมูลตรวจสอบ',
    icon: <SendIcon className="text-xl" />,
  },
  // เคส LINE ที่หลังบ้านตีกลับ — แยกจากหน้า input เพราะต้องให้คนที่ดูแชท OA เป็นคนตอบลูกค้า
  lineCase: {
    id: 'lineCase',
    route: 'workspace/lineCase',
    name: 'เคสจาก LINE',
    icon: <ChatIcon className="text-xl" />,
    feature: 'lineCase',
  },
  audit: {
    id: 'audit',
    //route: 'workspace/audit',
    name: 'ตรวจสอบ',
    icon: <FactCheckIcon className="text-xl" />,
    subLinkIds: ['auditCase', 'reportAdmin', 'reportAdminInput'],
  },
  activityCheck: {
    id: 'activityCheck',
    name: 'เช็คข้อมูลกิจกรรม',
    icon: <FactCheckIcon className="text-xl" />,
    subLinkIds: ['birthdayPromo'],
    feature: 'birthdayPromo',
  },
  reports: {
    id: 'reports',
    name: 'รายงาน',
    icon: <FileTextOutlined className="text-xl" />,
    subLinkIds: ['reportCase', 'errorSummary', 'auditCaseReport', 'auditReport', 'employeeCaseReport', 'workloadReport', 'kpiReport', 'attendanceReport', 'attendanceReportMonthly', 'activityLog'],
  },
  inputsData: {
    id: 'inputsData',
    route: 'admin/masterdata/input',
    name: 'Inputs Data',
    icon: <FileTextOutlined className="text-xl" />,
  },
  VIPData: {
    id: 'VIPData',
    route: 'workspace/vipMasterData',
    name: 'VIP Data',
    icon: <FontAwesomeIcon icon={faCrown} style={{ fontSize: '1rem' }} />,
  },
  blacklist: {
    id: 'blacklist',
    route: 'workspace/blacklist',
    name: 'Blacklist',
    icon: <FactCheckIcon className="text-xl" />,
  },
  telegram: {
    id: 'telegram',
    route: 'workspace/telegram',
    name: 'Telegram',
    icon: <SendIcon className="text-xl" />,
  },
  manualTimeclock: {
    id: 'manualTimeclock',
    route: 'workspace/manualTimeclock',
    name: 'แก้ manual เข้างาน ออกงาน',
    icon: <FieldTimeOutlined className="text-xl" />,
  },
  rawData: {
    id: 'rawData',
    name: 'Raw Data',
    icon: <TableChartIcon className="text-xl" />,
    subLinkIds: ['pickupTime'],
  },
  userData: {
    id: 'userData',
    route: 'workspace/userBank',
    name: 'User Data',
    icon: <ContactPageIcon className="text-xl" />,
    feature: 'userData',
  }
};

// =============================================================================
// PERMISSION MATRIX - รองรับทั้ง menu และ submenu permissions
// =============================================================================
const PERMISSION_MATRIX = {
  backoffice: {
    default: {
      menus: ['employees_backoffice', 'companies'],
    },
  },

  admin: {
    default: {
      menus: ['employees_admin', 'scheduleAdmin', 'addCaseSetting', 'setting', 'systemJob', 'lineChannel', 'telegramBot', 'telegramChatTarget', 'customfield', 'masterData'],
      // ถ้าไม่ระบุ submenus จะแสดงทั้งหมดตาม subLinkIds
    },
  },

  workspace: {
    '3': {
      [JOB_TYPE.admin_input]: {
        menus: ['input', 'lineCase'],
      },
      [JOB_TYPE.panel_output]: {
        menus: ['case', 'blacklist', 'telegram', 'activityCheck', 'userData'],
      },
      [JOB_TYPE.head]: {
        menus: ['dashboard', 'schedule', 'case', 'inputsData', 'VIPData', 'blacklist', 'telegram'],
      },
      [JOB_TYPE.auditor]: {
        menus: ['audit','reports'],
        // submenus: {
        //   audit: ['auditCase', 'reportAdmin', 'reportAdminInput'],
        //   reports: ['reportCase', 'errorSummary', 'auditCaseReport', 'auditReport', 'employeeCaseReport', 'workloadReport'],
        // },
      },
      [JOB_TYPE.marketing]: {
        menus: ['input'],
      },
    },
    default: {
      menus: ['dashboard', 'schedule', 'case', 'input', 'lineCase', 'audit', 'activityCheck', 'reports', 'inputsData', 'VIPData', 'blacklist', 'telegram', 'manualTimeclock', 'userData', 'rawData'],
      // ตัวอย่าง: control submenu permission
      // submenus: {
      //   reports: ['reportCase', 'auditCaseReport'], // เห็นแค่ 2 อัน
      // },
    },
  },
};


const buildSubLinks = (subLinkIds, allowedSubmenus = null) => {
  // ถ้ามี allowedSubmenus ให้ filter เฉพาะที่อนุญาต
  const filteredIds = allowedSubmenus
    ? subLinkIds.filter(id => allowedSubmenus.includes(id))
    : subLinkIds;

  return filteredIds
    .map(id => SUBMENU_ITEMS[id])
    .filter(Boolean);
};

// เมนูที่ผูกกับบางบริษัท (ระบบหลังบ้านคนละแบบ) — บริษัทอื่นซ่อนไปเลย
// ไม่ใช่แค่กันกดพลาด แต่เข้าไปก็ทำอะไรไม่ได้ backend ปฏิเสธอยู่แล้ว
// รายชื่อบริษัทที่เปิดอยู่ที่ src/data/companyFeatures.js ที่เดียว
const isMenuAllowedForCompany = (item) => hasCompanyFeature(item.feature);

const buildMenuItem = (itemId, options = {}) => {
  const item = MENU_ITEMS[itemId];
  if (!item) {
    console.warn(`Menu item "${itemId}" not found`);
    return null;
  }

  if (!isMenuAllowedForCompany(item)) return null;

  const menuItem = { ...item };

  // Handle badge
  if (item.hasBadge && options.caseCount > 0) {
    menuItem.badge = options.caseCount;
  }

  // Handle submenus with permission
  if (item.subLinkIds) {
    const allowedSubmenus = options.submenus?.[itemId] || null;
    const subLinks = buildSubLinks(item.subLinkIds, allowedSubmenus);

    // ถ้าไม่มี subLinks ที่ได้รับอนุญาต ไม่แสดง menu นี้
    if (subLinks.length === 0) {
      return null;
    }

    menuItem.subLinks = subLinks;
    delete menuItem.subLinkIds; // Remove the IDs, keep only the resolved subLinks
  }

  return menuItem;
};

const buildLinks = (permittedMenus, permittedSubmenus = null, options = {}) => {
  const buildOptions = { ...options, submenus: permittedSubmenus };

  const links = permittedMenus
    .map((itemId) => buildMenuItem(itemId, buildOptions))
    .filter(Boolean);

  return [{ title: '', links }];
};

export const getLinks = (profile, location, caseCount = 0, jobType) => {
  const options = { caseCount };

  const locationPermissions = PERMISSION_MATRIX[location];
  if (!locationPermissions) {
    console.warn(`Unknown location: ${location}`);
    return [];
  }

  // Workspace has special profile/jobType logic
  if (location === 'workspace') {
    const profileStr = String(profile);
    const profilePermissions = locationPermissions[profileStr];

    if (profilePermissions) {
      const jobTypePermissions = profilePermissions[jobType];
      if (jobTypePermissions) {
        return buildLinks(
          jobTypePermissions.menus,
          jobTypePermissions.submenus || null,
          options
        );
      }
      return [];
    }

    // Use default permissions
    const defaultPerms = locationPermissions.default;
    return buildLinks(defaultPerms.menus, defaultPerms.submenus || null, options);
  }

  // Non-workspace locations
  const defaultPerms = locationPermissions.default;
  return buildLinks(defaultPerms.menus, defaultPerms.submenus || null, options);
};

export { PERMISSION_MATRIX };
